import React from 'react';
import { CSSTransition } from 'react-transition-group';

import LoaderBox from '../loader-box';
import styles from './animated-loader-container.scss';
import transitionStyles from './animated-loader-transitions.scss';

const ANIMATION_TIMEOUT = 800;
const EXIT_TIMEOUT = 0;

interface AnimatedLoaderProps {
  shouldShowLoader?: boolean;
  isLoading: boolean;
  children: React.ReactNode;
}

const AnimatedLoader: React.StatelessComponent<AnimatedLoaderProps> = ({
  shouldShowLoader = true,
  isLoading,
  children,
}) => {
  const commonProps = {
    mountOnEnter: true,
    unmountOnExit: true,
    enter: true,
    timeout: { enter: ANIMATION_TIMEOUT, exit: EXIT_TIMEOUT },
    classNames: transitionStyles,
  };

  return (
    <div className={styles.container}>
      {shouldShowLoader && (
        <CSSTransition in={isLoading} {...commonProps}>
          <LoaderBox key="loaderBox" />
        </CSSTransition>
      )}
      <CSSTransition in={!isLoading} {...commonProps}>
        <div key="content">{children}</div>
      </CSSTransition>
    </div>
  );
};

export default AnimatedLoader;
